import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody } from "../../Components/CMI/primitives";
import { fmtEur, fmtPct } from "../../Components/CMI/charts";
import { I } from "../../Components/CMI/icons";
import PageHead, { SectionHead } from "../../Layouts/CMI/PageHead";
import { getIvghProyectos } from "../../helpers/ivghApi";

const IvghProyectos = () => {
  document.title = "IVGH Proyectos | CMI - Grupo Cucalón Estévez";
  const { year } = useSelector((s) => s.Filters);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);

  const load = useCallback(async (p = 1) => {
    setLoading(true);
    try {
      const res = await getIvghProyectos(year, "all", p, 50);
      setData(res);
      setPage(p);
    } catch (e) {
      console.error("[IVGH Proy]", e);
    } finally {
      setLoading(false);
    }
  }, [year]);

  useEffect(() => { load(1); }, [load]);

  const totalPages = data ? Math.ceil(data.total / data.limit) : 0;

  return (
    <div className="page-content">
      <PageHead icon={I.Briefcase} title="IVGH — Proyectos" sub="Detalle de asignaciones e importes por proyecto" />

      {loading && !data && (
        <div style={{ textAlign: "center", padding: 60, color: "var(--ce-fg-faint)" }}>Cargando…</div>
      )}

      {data && (
        <>
          <div style={{ fontSize: 13, color: "var(--ce-fg-faint)", marginBottom: 12 }}>
            {data.total} proyectos computables en {year}
            {totalPages > 1 && ` — Página ${page} de ${totalPages}`}
          </div>

          <Card>
            <CardBody>
              <div style={{ overflowX: "auto" }}>
                <table className="tbl" style={{ width: "100%", fontSize: 12 }}>
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>ID</th>
                      <th style={{ textAlign: "left" }}>Descripción</th>
                      <th style={{ textAlign: "left" }}>Cliente</th>
                      <th>Empresa</th>
                      <th>Estado</th>
                      <th>Importe s/IVA s/supl.</th>
                      <th>Suplidos</th>
                      <th style={{ textAlign: "left" }}>Gestores</th>
                      <th>Alertas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.proyectos.map((p) => (
                      <tr key={p.id} style={p.alertas.length > 0 ? { background: "#fff8e1" } : {}}>
                        <td style={{ textAlign: "left", fontFamily: "monospace" }}>{p.id}</td>
                        <td style={{ textAlign: "left", maxWidth: 250, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title={p.descripcion}>
                          {p.descripcion || "—"}
                        </td>
                        <td style={{ textAlign: "left", maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                          {p.cliente}
                        </td>
                        <td>{p.empresa}</td>
                        <td style={{ fontSize: 11 }}>{p.estado}</td>
                        <td style={{ fontWeight: 600 }}>{fmtEur(p.importe_sin_suplidos)}</td>
                        <td style={{ color: p.suplidos > 0 ? "var(--ce-warning)" : "var(--ce-fg-faint)" }}>
                          {p.suplidos > 0 ? fmtEur(p.suplidos) : "—"}
                        </td>
                        <td style={{ textAlign: "left", fontSize: 11 }}>
                          {p.reparto_manual && (
                            <div style={{ fontSize: 9, fontWeight: 600, color: "var(--ce-primary)", marginBottom: 2 }}>REPARTO MANUAL</div>
                          )}
                          {p.gestores.length === 0 ? (
                            <span style={{ color: "var(--ce-danger)" }}>Sin asignar</span>
                          ) : (
                            p.gestores.map((g, j) => (
                              <div key={j} style={{ opacity: g.computa_ivgh ? 1 : 0.4 }}>
                                {g.nombre}
                                {g.rol && (
                                  <span style={{ marginLeft: 4, fontSize: 9, padding: "0 4px", borderRadius: 4, background: "#eee" }}>
                                    {g.rol}
                                  </span>
                                )}
                                {g.computa_ivgh && g.porcentaje > 0 && (
                                  <span style={{ marginLeft: 4, color: "var(--ce-fg-faint)" }}>
                                    ({fmtPct(g.porcentaje, 0)} → {fmtEur(g.importe_asignado)})
                                  </span>
                                )}
                                {!g.computa_ivgh && (
                                  <span style={{ marginLeft: 4, fontSize: 10, color: "var(--ce-fg-faint)" }}>
                                    no computa
                                  </span>
                                )}
                              </div>
                            ))
                          )}
                        </td>
                        <td style={{ fontSize: 11 }}>
                          {p.alertas.map((a, j) => (
                            <div key={j} style={{ color: "var(--ce-warning)" }}>⚠ {a}</div>
                          ))}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>

          {totalPages > 1 && (
            <div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16 }}>
              <button className="btn btn-sm btn-outline-secondary" disabled={page <= 1} onClick={() => load(page - 1)}>
                ← Anterior
              </button>
              <span style={{ lineHeight: "30px", fontSize: 13 }}>Pág. {page} / {totalPages}</span>
              <button className="btn btn-sm btn-outline-secondary" disabled={page >= totalPages} onClick={() => load(page + 1)}>
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default IvghProyectos;
